import Shortcut from '@/domain/shortcuts';
import {
  getForLaunch,
  getForArchive,
} from '@/infra/shortcuts/shortcutsRepository';

export async function shorcutsForLaunchGetAll(): Promise<ResolvedData> {
  try {
    const res = await getForLaunch();
    const data: Shortcut[] = res.shortcuts.map((chunk) => new Shortcut(chunk));
    return { shortcuts: data };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export async function shorcutsForArchiveGetAll(): Promise<ResolvedData> {
  try {
    const res = await getForArchive();
    const data: Shortcut[] = res.shortcuts.map((chunk) => new Shortcut(chunk));
    return { shortcuts: data };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export interface ResolvedData {
  shortcuts: Shortcut[];
}
